import styled from 'styled-components'
import {device} from '../../../theme'

export const ContactFormWrapper = styled.section `
    padding-top: 100px;
    padding-bottom: 64px;
    @media ${device.medium}{
        padding-top: 15px;
        padding-bottom: 45px;
    }
    @media ${device.small}{
        padding-top: 10px;
        padding-bottom: 45px;
    }
`;

export const LeftBox = styled.div `
    @media ${device.medium}{
        margin-bottom: 45px;
    }
`;